import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { StubPage } from 'apps/auth/components/common/Layout/StubPage';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { CardAccountRow, CardAccountSubrow, IconWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import Notification from 'apps/auth/components/history/Notification';
import BasePageWithLeftMenu from 'apps/auth/components/utils/BasePageWithLeftMenu';
import { GA_MAIN_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PRODUCT_NAME } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { ACCOUNT } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { GA_ACCOUNT } from 'apps/auth/constants/Constants';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { formatMoney } from 'apps/auth/helpers/formats';
import { getCurrencyIcon, onIconRenderError } from 'apps/auth/helpers/utils';

import EmptyAccounts from './EmptyAccounts';
import EmptyAccountsGA from './EmptyAccountsGA';
import EmptyAccountsLibre from './EmptyAccountsLibre';
import { GaCardsContainer, GaCardsItem } from '../styles';
import AddNewAccountModal from './modals/AddNewAccountModal';
import AccountsTextPopup from './popups/AccountsTextPopup';

const GlobalAccounts = (props) => {
    const popupRef = useRef(null);
    const showModalTermsGaUpdateBlock = props.extra.show_modal_terms_ga_update_block;
    const hasAccounts = props.gaAccounts?.length > 0;

    useEffect(() => {
        if (__isBrowser__) {
            amplitude.getInstance().logEvent(GA_MAIN_SCREEN_SHOWN, {
                [PRODUCT_NAME]: ACCOUNT,
            });
        }
    }, []);

    const getCardIcon = (account) => {
        return (
            <>
                {account.hasLinkedPlasticCard && account.hasLinkedVirtualCard && <Icon name="cardp-both" color="primary" size="32px" />}
                {account.hasLinkedPlasticCard && !account.hasLinkedVirtualCard && <Icon name="cardp-full" color="primary" />}
                {!account.hasLinkedPlasticCard && account.hasLinkedVirtualCard && <Icon name="cardp" color="primary" />}
            </>
        );
    };
    const getPopupComponent = () => {
        return <AccountsTextPopup popupRef={popupRef} />;
    };

    const getAccounts = () => {
        if (props.isLibre) {
            return <>{!hasAccounts ? <EmptyAccountsLibre /> : renderGaAccounts()}</>;
        }

        return <>{showModalTermsGaUpdateBlock ? <EmptyAccountsGA /> : renderGaAccounts()}</>;
    };

    const renderGaAccounts = () => {
        if (hasAccounts) {
            return (
                <>
                    <HeaderPanel
                        title={props.headerTitle}
                        buttonRowCaption={props.isLibre ? '' : props.addCurrency}
                        buttonRowOnClick={(e) => {
                            e.preventDefault();
                            if (Array.isArray(props.availableAccounts) && props.availableAccounts.length) {
                                props.toggleModal(true, <AddNewAccountModal getCurrencyIcon={getCurrencyIcon} onError={onIconRenderError} />);
                            } else {
                                popupRef.current?.open();
                            }
                        }}
                    />
                    <GaCardsContainer>
                        {props.gaAccounts.map((account) => (
                            <GaCardsItem key={account.id}>
                                <Panel type="reactLink" to={`${AUTH_GA_POCKET}${account.id}`} hasBorderRadius isBordered>
                                    <CardAccountRow>
                                        <IconWrapper>
                                            <DiskBadge src={getCurrencyIcon(account.currencyIcon)} alt={account.currencyIcon} onError={onIconRenderError} />
                                        </IconWrapper>
                                        <CardAccountSubrow>
                                            <Text>
                                                {formatMoney(account.balance)}
                                                <Text smallCaps> {account.currencyIcon}</Text>
                                            </Text>
                                            {getCardIcon(account)}
                                        </CardAccountSubrow>
                                    </CardAccountRow>
                                </Panel>
                            </GaCardsItem>
                        ))}
                    </GaCardsContainer>
                    <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} />
                </>
            );
        } else {
            return <EmptyAccounts title={props.accountsCustomTitle} />;
        }
    };

    if (props.switchOffGlobalAccountTabs && !props.gaMigration) {
        return (
            <BaseLayout stateOptions={{ isGA: true }}>
                <MainColumn isGaMigration>
                    <StubPage isGaMigration />
                </MainColumn>
            </BaseLayout>
        );
    } else
        return (
            <MainColumn>
                <Notification />
                {getAccounts()}
            </MainColumn>
        );
};

const mapStateToProps = (state) => {
    return {
        gaAccounts: state.extra.gaAccounts,
        isLibre: state.extra.isLibre,
        availableAccounts: state.extra.availableAccounts,
        headerTitle: state.messages.pageMessages.headerTitle,
        accountsCustomTitle: state.messages.pageMessages.accountsCustomTitle,
        addCurrency: state.messages.pageMessages.addCurrency,
        switchOffGlobalAccountTabs: state.extra.switchOffGlobalAccountTabs,
        gaMigration: state.extra.gaMigration,
        extra: state.extra,
    };
};
GlobalAccounts.propTypes = {
    gaAccounts: PropTypes.array,
    headerTitle: PropTypes.string.isRequired,
    accountsCustomTitle: PropTypes.string.isRequired,
    extra: PropTypes.object,
};
export default connect(mapStateToProps, {
    toggleModal,
})(BasePageWithLeftMenu(GlobalAccounts, GA_ACCOUNT));
